import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useInProgressAttemptIds(studentId: string) {
  return useQuery({
    queryKey: ['in-progress-attempts', studentId],
    enabled: !!studentId,
    staleTime: 30_000,
    queryFn: async (): Promise<string[]> => {
      const { data } = await supabase
        .from('attempts')
        .select('exercise_id')
        .eq('student_id', studentId)
        .eq('status', 'in_progress')
        .eq('session_type', 'exercise');
      // exercise_id est nullable depuis les sessions Warmup → on filtre les null.
      return (data ?? []).map((r) => r.exercise_id).filter((id): id is string => id !== null);
    },
  });
}
